import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHasAccessServices } from 'components/hooks/services/useBoardServices';
import { RequestAccess } from 'components/common/request-access/RequestAccess';
import { BookmarkButton, BookmarkStarButton } from '../../myServicesPage/components/bookmark/BookmarkButtons';
import { TrackedFeature, TrackedPage, TRACKING_PARAM_KEYS } from 'services/Logger';
import { useLoggerTracking } from 'components/hooks/logger/useLoggerTracking';
import { BookmarkOrigin, Service } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';
import { ShareButton } from './ShareButton';

type ServiceDescriptionButtonsProps = {
    sgmService: Service;
};

export const ServiceDescriptionButtons: React.FunctionComponent<ServiceDescriptionButtonsProps> = ({
    sgmService: {
        serviceKey,
        title,
        url,
        shareModel,
        publicPageLink,
    },
}) => {
    const { hasAccessTo } = useHasAccessServices();
    const { t: translate } = useTranslation('service-description');
    const track = useLoggerTracking();

    if (!url || !serviceKey) {
        return <></>;
    }

    const canAccess = !!serviceKey && hasAccessTo(serviceKey);

    return <div className="d-flex flex-grow-1 mt-2">
        {canAccess
            ? <a
                href={url}
                onClick={() => track(TrackedPage.ServiceDetail, TrackedFeature.OpenService, { [TRACKING_PARAM_KEYS.serviceKey]: serviceKey })}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-lg btn-primary me-1"
            >{translate('service-description:access')}</a>
            : <RequestAccess
                serviceKey={serviceKey}
                name={title}
                url={url}
                buttonClass="btn-outline-socgen"
            />}
        {publicPageLink && <a
            href={publicPageLink}
            onClick={() => track(TrackedPage.ServiceDetail, TrackedFeature.OpenService, { [TRACKING_PARAM_KEYS.serviceKey]: serviceKey })}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-lg btn-flat-secondary me-1"
        >{translate('service-description:learnMore')}</a>
        }
        <div className="flex-grow-1" />
        <div className="d-block d-lg-none">
            <div className="d-block d-lg-none">
                <BookmarkStarButton
                    referenceId={serviceKey}
                    origin={BookmarkOrigin.SgmService}
                />
            </div>
        </div>
        <div className="d-none d-lg-block">
            <BookmarkButton
                referenceId={serviceKey}
                origin={BookmarkOrigin.SgmService}
            />
            <ShareButton url={url} share={shareModel} serviceKey={serviceKey} />
        </div>
    </div>;
};
